import axios from "axios";

import {buildSelectedComicQuery} from "../buildSelectedComicQuery.js";
import {grabMainComic} from "../grabMainComic.js";


export function getMainComic(comicID,changeMainComic){
    
    /////// 1. get the Main comicID from the API using the searchedCharacter in Redux
    /////// 2. then use grabMainComic() to clean up the returned data to only use what we need
    /////// 3. then store the end results into Redux with changeMainComic()


    var comicQuery = buildSelectedComicQuery(comicID);
    
    axios.get(comicQuery)
    .then(function (response1) {
        var comicData = grabMainComic(response1);
        //console.log(comicData);
        changeMainComic(comicData);
    })

}


// WEBPACK FOOTER //
// ./src/components/includes/axios/getMainComic.js